import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue} from 'bootstrap-vue';
import 'bootstrap/dist/css/bootstrap.css';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import '@fontsource-variable/montserrat';

import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";


Vue.config.productionTip = false

Vue.use(BootstrapVue);

Vue.component(VueSlickCarousel.name, VueSlickCarousel)

new Vue({
  render: h => h(App),
}).$mount('#app')
